import { styled, Theme } from '@mui/material';
import { Link } from 'react-router-dom';

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  '& p': {
    color: theme.palette.blue.light,
  },
  '&:hover p': {
    color: theme.palette.black.main,
    textDecoration: 'underline',
  },
}));

export const hrefLinkStyles = (theme: Theme) => ({
  textDecoration: 'none',
  color: theme.palette.blue.light,
  '&:hover': {
    color: theme.palette.black.main,
    textDecoration: 'underline',
  },
});
